'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["conversation", "selected", "unread", "focused", "ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationListItemAvatar = /*#__PURE__*/React.forwardRef(function ConversationListItemAvatar(props, ref) {
  const _ref = props,
    {
      conversation,
      selected = false,
      unread = false,
      focused = false,
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Use conversation-level avatar if provided, otherwise pick the first
  // non-'user' participant so the list shows the other person's avatar
  // instead of the local user's.
  const participant = conversation.participants?.find(p => p.role !== 'user') ?? conversation.participants?.[0];
  const avatarUrl = conversation.avatarUrl ?? participant?.avatarUrl;
  const avatarAlt = participant?.displayName ?? '';
  const ownerState = {
    conversation,
    selected,
    unread,
    focused
  };
  void ownerStateProp;
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  const Image = slots?.image ?? 'img';
  const imageProps = useSlotProps({
    elementType: Image,
    externalSlotProps: slotProps?.image,
    ownerState,
    additionalProps: {
      alt: avatarAlt,
      src: avatarUrl ?? undefined
    }
  });
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: avatarUrl ? /*#__PURE__*/_jsx(Image, _extends({}, imageProps)) : null
  }));
});
if (process.env.NODE_ENV !== "production") ConversationListItemAvatar.displayName = "ConversationListItemAvatar";